<template>
  <div class="fit">
    <GoSearch />
  </div>
</template>

<script>
// @ is an alias to /src
import GoSearch from "@/components/GoSearch.vue";

export default {
  name: "Go",
  components: {
    GoSearch
  },
  metaInfo: {
    title: "GO Search"
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/buefy.scss";
</style>
